import React, { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { Field, useFormik, FormikProvider } from "formik";
import HousingService from "../../Services/HousingService";
import NavigationServicesHeader from "../../Header/NavigationServicesHeader";
import { Form, FormGroup, Col, Table, Card } from "react-bootstrap";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment-timezone";
import jsPDF from "jspdf";
import {FaFileExcel, FaPrint} from "react-icons/fa";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { store } from "../../App";
import * as Yup from "yup";
import { useReactToPrint } from "react-to-print";
import { GetDetails, ModuleHeader } from "../utils/commonFunctions";

const DistrictWiseIncomeReport = () => {
  const today = new Date();
  const [details, setdetails] = useState();
  const [search, setSearch] = useState("");
  const [enable, setEnable] = useState(true);
  const [DistList, setDistList] = useState();
  const [show, setShow] = useState();
  const [districtwise, setDistrictWise] = useState();
  const [schemewise, setSchemewise] = useState();
  const [fdate, setFdate] = useState("");
  const [tdate, setTdate] = useState("");
  const [rep, setRep] = useState("");
  const [saveOptionDist, setSaveOptionDist] = useState([])
  const [distList1, setdistList1] = useState([]);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Income Report"
  });


  function generate() {
    const pageWidth = 210;
    const pageHeight = 297;
    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: [pageWidth, pageHeight] });

    const imgPath = "/img/APSHCL_logo.png";
    const headingText2 = "Andhra Pradesh State Housing Corporation Limited (APSHCL)";
    const headingText3 = `between ${fdate} and ${tdate}, `;
    const headingText4 = `${rep} INCOME REPORT of ${saveOptionDist} :District`;

    const fontSize = 10;
    const textWidth2 = (doc.getStringUnitWidth(headingText2) * fontSize) / doc.internal.scaleFactor;
    const textWidth3 = (doc.getStringUnitWidth(headingText3) * fontSize) / doc.internal.scaleFactor;
    const textWidth4 = (doc.getStringUnitWidth(headingText4) * fontSize) / doc.internal.scaleFactor;

    const tableYStart = 35;
    doc.setFontSize(fontSize);

    doc.setTextColor(0, 0, 0);
    const xCoordinate2 = (pageWidth - textWidth2) / 2;
    const xCoordinate3 = (pageWidth - textWidth3) / 2;
    const xCoordinate4 = (pageWidth - textWidth4) / 2;

    doc.text(headingText2, xCoordinate2, 10);
    doc.text(headingText4, xCoordinate4, 20);
    doc.text(headingText3, xCoordinate3, 30);

    doc.addImage(imgPath, "PNG", 7, 7, 25, 25);

    doc.autoTable({
      html: "#my-table",
      theme: "grid",
      tableWidth: "auto",
      columnStyles: {
        3: { cellWidth: "wrap" },
      },
      startY: tableYStart,
      margin: { top: 5, right: 15, bottom: 5, left: 15 },
      styles: {
        fontSize: 6,
      },
      columnWidth: { 0: 20, 1: 30, 2: 40 },
    });

    doc.save("IncomeReport.pdf");
  }


  React.useEffect(() => {
    setEnable(true)
    HousingService.districtlist().then((res) => {
      if (res.data) {
        setdistList1(res.data)
        let options = res.data.map((item, i) => {
          return (<option key={i} value={item.dist_code}> {item.dist_name} </option>);
        });
        setDistList(options);
      }
    });
  }, []);

  const validationSchema = Yup.object({
    fromdate: Yup.date()
      .required("please select fromdate")
      .max(today, "Should not be Greater than Current date"),
    todate: Yup.date().when(["fromdate"], (fromdate, schema) => { return fromdate ? schema.min(fromdate, "shouldnot be less than from date").max(today, "Should not be Greater than Current date") : schema.max(0); })
      .required("Please Enter Valid Date"),
    report_type: Yup.string().required("please select")
  });

  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;
  const firstDayOfMonth = `${currentYear}-${currentMonth
    .toString()
    .padStart(2, "0")}-01`;

  const formik = useFormik({
    initialValues: {
      report_type: "",
      fromdate: firstDayOfMonth,
      todate: today.toISOString().substr(0, 10),
      phase_district: "0"
    },

    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("distrxits", values.phase_district)
      if (values.phase_district === "0") { setSaveOptionDist("All") }
      else { let dist = distList1.find((item) => item.dist_code == values.phase_district) ;setSaveOptionDist(dist?.dist_name) }
      setFdate(moment(values.fromdate).format("DD/MM/YYYY"));
      setTdate(moment(values.todate).format("DD/MM/YYYY"));
      setRep(values.report_type);
      let params = { fromdate: moment(values.fromdate).format("DD/MM/YYYY"), todate: moment(values.todate).format("DD/MM/YYYY"), report_type: values.report_type, dist_code: formik.values.phase_district };
      if (values.report_type === "DistrictWise") {
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.Ofms_Income(params).then((response) => {
          if (response.data) { setdetails(response.data); store.dispatch({ type: "HIDE_SPINNER" }); setShow(true); setDistrictWise(true); setSchemewise(false); }
        });
      }
      if (values.report_type === "SchemeWise") {
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.Ofms_Income(params).then((response) => {
          setdetails(response.data); store.dispatch({ type: "HIDE_SPINNER" }); setShow(true); setDistrictWise(false); setSchemewise(true);
        });
      }
    }
  });

  return (
    <>
      <NavigationServicesHeader />
      <FormikProvider value={formik}>
      <Form onSubmit={formik.handleSubmit}>
       <ModuleHeader title="Income Report" />
          <OFMSUI.Container fluid className="outer-page-content-container " style={{ width: "90%" }} >
            <OFMSUI.Row >
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" > <label> <b>Report Type</b> </label> <span className="mandatory" style={{ color: "red" }}> * </span>
                <Field component="select" name="report_type" className={formik.touched.report_type && formik.errors.report_type ? "form-control is-invalid" : "form-control"} >
                  <option value="">Select</option>
                  <option value="DistrictWise">District-Wise</option>
                  <option value="SchemeWise">Scheme-Wise</option>
                </Field>
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <label> <h6>District</h6> </label> <span className="mandatory" style={{ color: "red" }}>  * </span>
                <Field component="select" name="phase_district" className={formik.touched.phase_district && formik.errors.phase_district ? "form-control is-invalid" : "form-control"} >
                  <option value="">Select</option>
                  <option value="0">All</option> {DistList}
                </Field>
              </OFMSUI.Col>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <FormGroup as={Col}>
                  <div> <label> <b>From Date</b> </label> <span className="mandatory" style={{ color: "red" }}> * </span> <Field name="fromdate" placeholder="Please select date" className={formik.touched.fromdate && formik.errors.fromdate ? "form-control is-invalid" : "form-control"} type="date" /> </div>
                </FormGroup>
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <FormGroup as={Col}>
                  <div> <label> <b>To Date</b> </label> <span className="mandatory" style={{ color: "red" }}> * </span> <Field name="todate" className={formik.touched.todate && formik.errors.todate ? "form-control is-invalid" : "form-control"} type="date" /> </div>
                </FormGroup>
              </OFMSUI.Col>
              <GetDetails/>
            </OFMSUI.Row>
            {enable === true && (
              <>
                <div>
                  {show && (
                    <>
                      <h2 className="autoTable"></h2>
                      <Card style={{ marginTop: "25px" }}>
                        <Card.Body> <button className="btn btn-danger btn-sm" onClick={generate} style={{ float: "right", marginLeft: "3px" }} type="button" > PDF <MdOutlinePictureAsPdf /> </button>
                          <button className="btn btn-success btn-sm" style={{ float: "right" }} type="button" >
                            <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table" filename=" Income Report" sheet="tablexls" buttonText="Excel" style={{ color: "blue" }} >
                              <FaFileExcel />
                            </ReactHTMLTableToExcel>
                          </button>
                          <button className="btn btn-warning btn-sm" onClick={handlePrint} style={{ float: "right" }} type="button" > Print <FaPrint /> </button>
                          <input type="text" id="" placeholder="Search By District Name" style={{ width: 250, marginBottom: "5px" }} className="form-control input-lg" onChange={(event) => setSearch(event.target.value)} ></input>
                          <div ref={componentRef} className="print-content">
                            <Table id="my-table" className="table table2 table-bordered table-hover" role="grid" aria-describedby="example_info"
                            >
                              {show && (
                                <thead className="fw-bold" style={{ position: "sticky", top: "0px" }} >
                                                        <tr>
                        {" "}
                        <th colSpan={10} style={{ textAlign: "center" }}>
                          {" "}
                          <h6>
                          Income Report of {saveOptionDist} District from{" "}
                            {fdate} to {tdate}{" "}
                            of Report type: {rep} 
                          </h6>{" "}
                        </th>{" "}
                      </tr>

                                  <tr className="table_countshead">
                                    <th rowSpan={2}>Sno</th>
                                    {districtwise && (<th rowSpan={2}>District</th>)}
                                    {schemewise && (<th rowSpan={2}>Phase name</th>)}
                                    <th style={{ textAlign: "right" }} rowSpan={2}>Admin Fee</th>
                                    <th style={{ textAlign: "right" }} rowSpan={2}>Admin Charges</th>
                                    <th style={{ textAlign: "right" }} rowSpan={2}>Beneficiary Contribution </th>
                                    <th style={{ textAlign: "center" }} colSpan={2}>Cement </th>
                                    <th style={{ textAlign: "center" }} colSpan={2}>Steel </th>
                                    <th style={{ textAlign: "right" }} rowSpan={2}>Total Income</th>
                                  </tr>
                                  <tr className="table_countshead">
                                    <th style={{ textAlign: "right" }}>No.of Bags Issued </th>
                                    <th style={{ textAlign: "right" }}>Diff. Cost 6 Rs. upto 08-03-2022 then 7 Rs. per Bag </th>
                                    <th style={{ textAlign: "right" }}>Issued Qty (in Kgs.)</th>
                                    <th style={{ textAlign: "right" }}>Diff. Cost 1.5/- per Kgs</th>
                                  </tr>

                                </thead>
                              )}
                              <tbody>
                                {details?.filter((element) => element.dist_name.toLowerCase().includes(search.toLowerCase())).map((data, i) => (<tr key={i}> <td> {i + 1}</td>
                                  {districtwise && (<td>{data.dist_name}</td>)}
                                  {schemewise && (<td>{data.phase_name}</td>)}
                                  <td style={{ textAlign: "right" }}>{parseInt(data.admin_fee) || 0}</td>
                                  <td style={{ textAlign: "right" }}>{parseInt(data.admin_charge) || 0}</td>
                                  <td style={{ textAlign: "right" }}>{parseInt(data.ben_contr) || 0}</td>
                                  <td style={{ textAlign: "right" }}>{parseInt(data.no_bags) || 0}</td>
                                  <td style={{ textAlign: "right" }}>{parseInt(data.bags_amount) || 0}</td>
                                  <td style={{ textAlign: "right" }}>{parseInt(data.steel_qty) || 0}</td>
                                  <td style={{ textAlign: "right" }}>{parseInt(data.steel_amount) || 0}</td>
                                  <td style={{ textAlign: "right" }}>{parseInt(data.tot_amount) || 0}</td>
                                </tr>
                                ))}
                                {details?.length === 0 && (<tr> <td style={{ fontSize: "20px", textAlign: "center", color: "red" }} > No Details Found. </td> </tr>)}
                              </tbody>
                              <tfoot>
                                <tr className="table_countshead" style={{ textAlign: "right" }}>
                                  <td colSpan={2}>Total</td>
                                  <td> {details?.reduce((a, v) => a + parseInt(v.admin_fee), 0)} </td> <td> {details?.reduce((a, v) => a + parseInt(v.admin_charge), 0)} </td>
                                  <td> {details?.reduce((a, v) => a + parseInt(v.ben_contr), 0)} </td> <td> {details?.reduce((a, v) => a + parseInt(v.no_bags), 0)} </td>
                                  <td>{details?.reduce((a, v) => a + parseInt(v.bags_amount), 0)} </td> <td> {details?.reduce((a, v) => a + parseInt(v.steel_qty), 0)} </td>
                                  <td> {details?.reduce((a, v) => a + parseInt(v.steel_amount), 0)} </td> <td> {details?.reduce((a, v) => a + parseInt(v.tot_amount), 0)} </td>
                                </tr>
                              </tfoot>
                            </Table>
                          </div>
                        </Card.Body>
                      </Card>
                    </>
                  )}
                </div>
              </>
            )}
          </OFMSUI.Container>
        </Form>
      </FormikProvider>
    </>
  );
};
export default DistrictWiseIncomeReport;
